/** @jsx jsx */
import { jsx } from '@emotion/core';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import PropTypes from 'prop-types';
import {
  bannerTopCss,
  bannerTopLinkCss,
  bannerTopLinkIconCss,
} from './index.styles';

function setArrowRightIcon() {
  return {
    __html:
      '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="7.5px" height="14.5px" data-di-res-id="cfaabaad-6279d6c1" data-di-rand="1602169303269"><path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="1px" stroke-linecap="butt" stroke-linejoin="miter" fill="none" d="M1.618,0.536 L5.931,6.584 L1.618,12.632 "></path></svg>',
  };
}

class BannerTop extends SafePureComponent {
  safeRender() {
    const link = this.props.fields.Link.value;

    return (
      <div css={bannerTopCss} id="covid19-banner">
        <a css={bannerTopLinkCss} href={link.href} target={link.target}>
          {link.text}
          <span
            css={bannerTopLinkIconCss}
            dangerouslySetInnerHTML={setArrowRightIcon()}
          ></span>
        </a>
      </div>
    );
  }
}

BannerTop.displayName = 'BannerTop';

BannerTop.defaultProps = {
  bannerText: '',
  bannerLink: '',
  linkTarget: '_self',
};

BannerTop.propTypes = {
  bannerText: PropTypes.string,
  bannerLink: PropTypes.string,
  linkTarget: PropTypes.string,
};

export default BannerTop;
